export const DEFAULT_MY_ACCOUNT_PATH = 'my-account';
